import { render, staticRenderFns } from "./CentroTrabajoList.vue?vue&type=template&id=11c2de2a&scoped=true&"
import script from "./CentroTrabajoList.vue?vue&type=script&lang=js&"
export * from "./CentroTrabajoList.vue?vue&type=script&lang=js&"
import style0 from "./CentroTrabajoList.vue?vue&type=style&index=0&id=11c2de2a&prod&lang=scss&scoped=true&"
import style1 from "./CentroTrabajoList.vue?vue&type=style&index=1&id=11c2de2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c2de2a",
  null
  
)

export default component.exports